module.exports = __webpack_public_path__ + "static/media/logo.6861b7e1.svg";